export const loadContainerParameters = 'loadContainerParameters';
export const loadContainerPriceMaps = 'loadContainerPriceMaps';
export const loadPickupPlaces = 'loadPickupPlaces';
